// extracted by mini-css-extract-plugin
export default {"container":"TheresAnOption_container__gRcTB","left":"TheresAnOption_left__AhRy+","title":"TheresAnOption_title__NAfE5","content":"TheresAnOption_content__CXItN"};